export default {
	tables: {
		filterConfirm: 'Ok',
		filterReset: 'Resetear',
		emptyText: 'Sin resultados'
	}
};
